require('./records/NookalPatient');
